var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBScales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-scales",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-scales1",
    serifid: "iconB-scales"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,17l0,-0.226c0.001,-0.345 0.008,-0.529 0.036,-0.708c0.033,-0.206 0.086,-0.407 0.16,-0.601c0.069,-0.182 0.162,-0.356 0.357,-0.699l3.579,-6.262c0.088,-0.155 0.216,-0.283 0.372,-0.372c0.103,-0.059 0.215,-0.099 0.332,-0.118l5.164,-0.861l0,-4.153c0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,3.82l4.836,-0.806c0.228,-0.038 0.46,0.004 0.66,0.118c0.155,0.088 0.283,0.216 0.372,0.372l3.579,6.262c0.195,0.343 0.288,0.517 0.357,0.699c0.074,0.194 0.127,0.396 0.16,0.601c0.028,0.179 0.034,0.363 0.035,0.709l0,0.025l0.001,0.006l0,0.194c0,2.761 -2.239,5 -5,5c-2.761,-0 -5,-2.239 -5,-5l0,-0.226c0.001,-0.345 0.008,-0.529 0.036,-0.708c0.033,-0.205 0.086,-0.407 0.16,-0.601c0.069,-0.182 0.162,-0.356 0.357,-0.699l2.534,-4.433c0,-0 -3.927,0.654 -3.938,0.656l-4.568,0.761l2.866,5.016c0.195,0.343 0.288,0.517 0.357,0.699c0.074,0.194 0.127,0.395 0.16,0.601c0.028,0.18 0.034,0.363 0.035,0.709l0,0.025l0.001,0.006l0,0.194c0,2.761 -2.239,5 -5,5c-2.761,0 -5,-2.239 -5,-5Zm8,0l-6,0c0,1.657 1.343,3 3,3c1.657,0 3,-1.343 3,-3Zm-3,-5.984l-2.277,3.984l4.554,0l-2.277,-3.984Zm9.723,1.984l4.554,0l-2.277,-3.984l-2.277,3.984Zm5.277,2l-6,0c0,1.657 1.343,3 3,3c1.657,0 3,-1.343 3,-3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBScales);
export default __webpack_public_path__ + "static/media/iconB-scales.9d2cc62ea523e9971fe28c64ed0d3484.svg";
export { ForwardRef as ReactComponent };